import React, { Component } from 'react';
import { Tabs } from 'antd';
import LstdtjTable from './table/index';
import css from './index.css';
export default class Lstdtj extends Component {

  render() {
    // 42 本科生  
    // 431硕士研究生  
    // 432博士研究生
    const tabs = [['42'], ['431', '432']]
    return (
      <div className={css.white_backgroud}>
        <Tabs>
          <Tabs.TabPane tab="本科生" key="1">
            <LstdtjTable xslbm={['42']} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="研究生" key="2">
            <LstdtjTable xslbm={['431', '432']} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/swbl/lstdtj/index.js